import React from "react";
import { Link } from "react-router-dom";
import { FaStore, FaPhone } from "react-icons/fa6";

export default function MobileSideMenu({ items = [], onNavigate }) {
  return (
    <div className="flex h-full flex-col justify-between gap-8 p-2 bg-white">
      <div className="space-y-6">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-emerald-700">
            Explore
          </p>
          <h2 className="mt-2 brand-serif text-3xl font-bold text-slate-950">
            Menu
          </h2>
        </div>
        <nav className="grid gap-2">
          {items.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={onNavigate}
              className="rounded-2xl border border-black/5 bg-white px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-emerald-200 hover:bg-emerald-50 hover:text-emerald-800"
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <Link to="/login" className="floating-pill text-md">
          লগইন
        </Link>
        <div className="grid gap-3 rounded-lg bg-slate-950 p-5 text-white">
          <div className="flex items-center gap-3">
            <FaStore className="h-5 w-5 text-amber-300" />
            <div>
              <p className="text-sm font-semibold">Need help?</p>
              <p className="text-xs text-white/70">
                Support is ready for orders and size help.
              </p>
            </div>
          </div>
          <a
            href="tel:01918-090266"
            className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-3 text-sm font-semibold"
          >
            <FaPhone /> Call Now
          </a>
        </div>
      </div>
      <div className="rounded-lg border border-emerald-100 bg-emerald-50 p-4 text-sm text-emerald-900">
        <p className="font-semibold">Guest checkout only</p>
        <p className="mt-1 text-emerald-800/80">
          Fast ordering, no registration required.
        </p>
      </div>
    </div>
  );
}
